
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { autoTranslate } from '@/helpers/autoTranslate';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => () => {} },
    parent: { type: Object, default: () => {} },
    errorResponse: { type: Object, default: () => {} },
    rowDisabled: { type: Boolean, default: false }
  },
  data(): {
    isLoading: boolean,
    search: string | null,
    searchResults: any[],
    searchTimerId: any
  } {
    return {
      isLoading: false,
      search: null,
      searchResults: [],
      searchTimerId: null
    }
  },
  computed:{
    rules: function (): any[] {
      const rules: any = [];
      if (this.input && this.input.required) {
        const rule = (value: any) => !!value || 'Required';
        rules.push(rule);
      }
      return rules;
    },
    autoTranslatedLabel: function(): string {
      return autoTranslate(this.input.label);
    },
    getItems: function (): any[] {
      let inputItemsArray = [];
      if(this.input.dropdownType === 'static') {
        inputItemsArray = JSON.parse(this.input.items);
      } else {
        inputItemsArray = this.getVariable(this.input.items) ? this.getVariable(this.input.items) : [];
      }
      const resolvedInputItems =  inputItemsArray.map((item: any) => {
        let text = this.input.itemText ? _.get(item, this.input.itemText): item;
        if(this.input.formula) {
          text = this.parent._resolveFormulaValue(this.input.formula, { _item: item })
        }
        const value = this.input.itemValue ? _.get(item, this.input.itemValue): item;
        return { text, value };
      });
      if(this.input.dropdownType === 'search') {
        return _.unionBy(resolvedInputItems, this.searchResults, 'value');
      }
      return resolvedInputItems;
    },
    ...mapGetters(['getErrorFor'])
  },
  watch: {
    getItems() {
      if(this.input.multiple && this.getItems.length > 0) this.removeInvalidValues();
    },
    search (val) {
      if (!val) {
        return;
      }
      this.isLoading = true;
      this.fetchEntriesDebounced();
    }
  },
  mounted() {
    this.$watch(
      () => this.getVariable(this.input.variable), 
      (newDropdownValue, oldDropdownValue) => {
        if((newDropdownValue === 0 || newDropdownValue) && newDropdownValue !== oldDropdownValue) {
          const inputItemsArray: any[] = this.getVariable(this.input.items) || [];
          const selectedObject = inputItemsArray.find((item: any) => _.get(item, this.input.itemValue) == newDropdownValue);
          this.onChange(this.input.onVarUpdate, { selectedObject });
          if(!oldDropdownValue && this.input.multiple) {
            this.removeInvalidValues();
          }
        }
      }, 
      { immediate: true, deep: true }
    )
  },
  methods: {
    onValueChange(event: string) {
      if(this.input.dropdownType == 'search') {
        this.updateSelectedItems(event);
      }
      this.onChange(this.input.onChange,{ selectedObject: this.getVariable(this.input.itemValue, { startingKey: this.input.items, findWithinStartingKey: event })});
      this.search = '';
    },
    updateSelectedItems(dropdownValue: any) {
      if(this.input.multiple) {
        this.searchResults = _.filter(this.getItems, (item: any) => _.includes(dropdownValue, item.value));
      } else {
        this.searchResults = this.getItems.filter((item: any) => item.value == dropdownValue);
      }
    },
    removeInvalidValues() {
      const currentValue: any = this.getVariable(this.input.variable);
      if(currentValue == undefined || this.getItems.length < 1) return;
      const filteredValues = this.getItems.filter((item: any) => currentValue.includes(item.value)).map(item => item.value);
      const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
      this.$set(this.getVariable(prefix), key, filteredValues);
    },
    fetchEntriesDebounced() {
      clearTimeout(this.searchTimerId)
      this.searchTimerId = setTimeout(async () => {
        await this.parent._callMultipleFunctions(this.input.searchFunctions, this.search);
        this.isLoading = false;
      }, 500) /* 500ms throttle */
    }
  }
})
